module.exports = __webpack_public_path__ + "static/media/charts_title.a8fef460.png";


//////////////////
// WEBPACK FOOTER
// ./src/peaceSharkIndex/index/img/charts_title.png
// module id = 1453
// module chunks = 0